// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3l2_M","colMin":"styles_colMin__12jV8"};